import React from 'react'
import { ModalRouter } from 'experienceComponents/CreateInstanceShared'

const CreateSmallGroupModalRouter = props => {
  return <ModalRouter {...props} componentType="smallGroup" />
}

export default CreateSmallGroupModalRouter
